import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { chatCopyProgressStore } from "@shared/libs/Global";

/**
 * 챗봇 행복사 진행 — 복사가 일어나는 메뉴 화면을 덮고 가운데에 진행 창을 띄운다 (2026-10-16).
 * 조회 중 덮개(CommonSpinner)와 같은 자리 · 같은 공통 틀(MainLayout 탭)이라 메뉴마다 코딩하지 않는다.
 * 창 모양은 챗봇 "대화 내보내기" 진행 창(공통 팝업 + ChatExportProgress)을 따른다 — 제목 · 진행 막대 · 퍼센트 · 안내.
 * 끝나면 저절로 사라진다(결과는 챗봇 말풍선). 덮여 있는 동안 화면을 누를 수 없다 — 복사 도중 사람이 줄을 건드리지 않게.
 * 숫자는 이 창만 다시 그린다 — 챗봇 창 전체를 다시 그리면 그리드가 바쁜 동안 밀려 한 번도 안 보였다.
 * 2026-10-22 회의록 전사도 이 창을 쓴다 — 제목 · 문구를 넘기면 그것을, 안 넘기면 행복사 문구 그대로.
 * 할 일 수(total)를 모르는 단계(음성 나누기)는 막대만 흐르고 퍼센트를 감춘다.
 */
export default function ChatCopyProgress({ cdMenu }: { cdMenu: string }) {
  const progress = chatCopyProgressStore((state) => state.progress[cdMenu]);
  if (!progress) return null;

  const known = progress.total > 0;
  const percent = known
    ? Math.min(100, Math.round((progress.done / progress.total) * 100))
    : 0;
  const title = progress.title ?? "행 복사";
  const message =
    progress.message ?? `${progress.done} / ${progress.total}건 복사 중입니다.`;

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 52,
        background: "rgba(0, 0, 0, 0.3)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "auto",
      }}
    >
      <Paper
        sx={{
          width: 360,
          padding: "15px",
          borderRadius: "8px",
          boxShadow:
            "0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)",
        }}
      >
        <Typography variant="h6" component="div">
          {title}
        </Typography>
        <div style={{ display: "flex", flexDirection: "column", gap: 10, padding: "12px 6px 6px" }}>
          <LinearProgress
            variant={known ? "determinate" : "indeterminate"}
            value={percent}
            sx={{ height: 10, borderRadius: 5 }}
          />
          {known && (
            <div style={{ color: "#475569", fontSize: 13, textAlign: "center" }}>{percent}%</div>
          )}
          <div style={{ color: "#1f2937", fontSize: 15, textAlign: "center" }}>{message}</div>
        </div>
      </Paper>
    </div>
  );
}
